import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { OfferProbability } from "@/hooks/use-offers";
import { OFFER_PROBABILITY_LABELS } from "@/lib/offer-pipeline-calc";

const STYLES: Record<OfferProbability, string> = {
  low: "bg-amber-100 text-amber-700",
  likely: "bg-blue-100 text-blue-700",
  very_likely: "bg-emerald-100 text-emerald-700",
};

/** null = ikke satt ennå — vises som et nøytralt "Sett sannsynlighet"-hint. */
export function OfferProbabilityBadge({ probability }: { probability: OfferProbability | null }) {
  if (!probability) {
    return (
      <Badge variant="outline" className="text-xs text-muted-foreground border-dashed">
        Sett sannsynlighet
      </Badge>
    );
  }
  return (
    <Badge variant="secondary" className={cn("text-xs", STYLES[probability])}>
      {OFFER_PROBABILITY_LABELS[probability]}
    </Badge>
  );
}
